/* eslint-disable */
export default {
  createLog: 'Lijst maken',
  creating: 'Wordt gemaakt',
  save: 'Opslaan',
  saving: 'Wordt opgeslagen',
  saved: 'Opgeslagen',
  view: 'Weergeven',
  creatingFailed: 'Maken mislukt.',
  savingFailed: 'Opslaan mislukt.',
} as const;

// @key: @#@"createLog"@#@ @source: @#@"Create Log"@#@
// @key: @#@"creating"@#@ @source: @#@"Creating"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
// @key: @#@"saving"@#@ @source: @#@"Saving"@#@
// @key: @#@"saved"@#@ @source: @#@"Saved"@#@
// @key: @#@"view"@#@ @source: @#@"View"@#@
// @key: @#@"creatingFailed"@#@ @source: @#@"Creating failed."@#@
// @key: @#@"savingFailed"@#@ @source: @#@"Saving failed."@#@
